var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCannabis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000356453 0.000356453H8.40246L6.3562 3.95595L6.31172 4.283L10.1326 19.0855L0.000356453 9.16024V2.37437L5.96203 6.02812L6.14454 5.8927L5.8551 4.77394L5.80035 4.69983L0.000356453 1.14539V0V0.000356453ZM9.58217 0.000356453H13.2395L15.45 4.26001L11.4145 19.8619L7.37901 4.26001L9.58253 0.000748552L9.58217 0.000356453ZM14.42 0.000356453H22.8287V1.14575L17.0283 4.70023L16.9736 4.7743L16.6841 5.89306L16.8666 6.02848L22.8283 2.37476V9.16059L12.6961 19.0859L16.5133 4.32791L16.4852 3.9994L14.4192 0.000748552L14.42 0.000356453ZM22.8287 10.5323V12.2617L22.0081 12.2099L20.9996 13.1976L22.8287 13.3107V18.2745L13.3311 19.9305L22.8287 10.5323ZM22.8287 19.3392V21.9136L21.0565 20.2145L19.7757 20.4375L22.2691 22.8283H16.1599L13.2009 21.0175L22.8283 19.3389L22.8287 19.3392ZM14.1524 22.8287H8.67657L11.1269 21.3293H11.7025L14.1528 22.8287H14.1524ZM6.66867 22.8287H0.55956L3.05288 20.4379L1.77207 20.2149C1.18185 20.7817 0.591304 21.3482 0.000356453 21.9143V19.3392L9.6278 21.0179L6.66867 22.8287ZM0.000356453 18.2745V13.3107L1.82903 13.1976L0.820484 12.2099L0 12.2617V10.5327L9.49748 19.9305L0 18.2745H0.000356453Z",
    fill: "#80C04D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannabis);
export default __webpack_public_path__ + "static/media/cannabis.09950eb2c9f928b5e265551f01d45d22.svg";
export { ForwardRef as ReactComponent };